export default {
  state: {
    ShowAddTeacherModal: false
  },
  getters: {
    getShowAddTeacherModal: state => state.ShowAddTeacherModal
  },
  mutations: {
    SetShowAddTeacherModal (state, val) {
      state.ShowAddTeacherModal = val
    }
  }
}
